import React from 'react';

import { ajax } from '@ifeng-fe/ui_base';

const getUrl = () => {
    const url = window.location.href;
    const path = window.location.pathname.split('preview')[0];
    /* eslint-disable no-undef */

    if (FullPagePreviewUrl.includes('shanklist')) {
        return `${FullPagePreviewUrl}${path.split('shanklist/').join('')}preview`;
    } else if (FullPagePreviewUrl === '') {
        return `${url.split('preview')[0]}preview`;
    } else {
        return `${FullPagePreviewUrl}${path}preview`;
    }
    /* eslint-enable no-undef */
};

try {
    if (
        typeof window !== 'undefined' &&
        window.location.href.includes('preview') &&
        window.location.href.includes('count__')
    ) {
        document.getElementsByTagName('html')[0].style.visibility = 'hidden';
        const xhr = new XMLHttpRequest();

        if (window.location.href.indexOf('biz=true') > 0) {
            xhr.open('GET', 'https://bizucms.ifeng.com/api/heartbeat', true);
        } else {
            xhr.open('GET', 'https://ucms.ifeng.com/api/heartbeat', true);
        }

        xhr.ontimeout = () => {
            window.location.href = window.location.href.split('/preview')[0];
        };
        xhr.onerror = () => {
            window.location.href = window.location.href.split('/preview')[0];
        };
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    document.getElementsByTagName('html')[0].style.visibility = '';
                } else {
                    window.location.href = window.location.href.split('/preview')[0];
                }
            }
        };
        xhr.timeout = 2000;
        xhr.send(null, '');
    }
} catch (error) {
    window.location.href = window.location.href.split('/preview')[0];
}

try {
    let updateTime = Date.now();

    if (
        typeof window !== 'undefined' &&
        window.location.href.includes('preview') &&
        window.location.href.includes('count__')
    ) {
        const url = getUrl();
        const uid = window.location.href.match(/([0-9a-z-]+)\/count__/)[1];
        // const uid = window.location.href.split('preview/')[1].split('/count__')[0];

        setInterval(() => {
            ajax(url, {
                type: 'POST',
                cache: false,
                data: {
                    action: 'get_update_time',
                    uid,
                },
            }).then(result => {
                if (result.code === 0) {
                    if (updateTime < result.data) {
                        updateTime = result.data;
                        const url = window.location.href;
                        const hrefs = window.location.href.split('count__');

                        hrefs[1] = Date.now();
                        if (url.includes('/app') && url.includes('/preview')) {
                            window.location.href = `${hrefs.join('count__')}/app`;
                        } else {
                            window.location.href = hrefs.join('count__');
                        }
                    }
                } else {
                    alert(`${result.message} 请关闭页面，刷新可视化编辑页后再进行操作`);
                }
            });
        }, 5000);
    }
} catch (error) {
    console.log(error);
}

export default () => {
    return null;
};
